module.exports = __webpack_public_path__ + "img/banner_2000x2.a4007fb0.jpg";